import getNonLeadMessageName from 'lib/getNonLeadMessageName.js';

const getLeadMessageName = (message = {}) => {
  if (!message) {
    return 'No first or last name available';
  }
  if (message.full_name) {
    return message.full_name;
  }

  if (message.first_name) {
    return `${message.first_name || ''} ${message.last_name || ''}`.trim();
  }

  if (message.lead) {
    return `${message.lead.first_name || ''} ${message.lead.last_name || ''}`.trim();
  }

  return getNonLeadMessageName(message);
};

export default getLeadMessageName;
